export default __webpack_public_path__ + "static/SO-intro-6a7790fdd79ce48eea3a6b1e11a3968f.mp4";